export default "__VITE_ASSET__CqTVKLRs__"